import { Component, OnInit, Input } from '@angular/core';
import { PageNotification, PageNotificationLocation, PageNotificationType } from 'src/app/models/page-notification';
import { PageNotificationService } from 'src/app/api/page-notification.service';
import { getLocaleDateFormat } from '@angular/common';

@Component({
  selector: 'page-notification',
  templateUrl: './page-notification.component.html',
  styleUrls: ['./page-notification.component.scss']
})
export class PageNotificationComponent implements OnInit {
  @Input() location: PageNotificationLocation;

  data: PageNotification[];

  constructor(private pageNotificationService: PageNotificationService) { }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.pageNotificationService.get([this.location]).subscribe(response => {
      this.data = response;
    });
  }

  getClass(item: PageNotification) {
    switch (item.type) {
      case  PageNotificationType.INFO:
        return 'alert alert-info';
      case  PageNotificationType.IMPORTANT:
        return 'alert alert-warning';
      case  PageNotificationType.ALERT:
        return 'alert alert-danger';
      default:
        return null;
    }
  }

  close(item: PageNotification) {
    this.data.splice(this.data.indexOf(item), 1);
    this.pageNotificationService.close(item.id).subscribe();
  }

}
